var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Popup',{attrs:{"visible":_vm.visible,"title":"绑定微信"},on:{"hide":_vm.hidePopup}},[_c('div',{attrs:{"id":"qrcode-box"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }